<template>
  <zj-layout-container v-loading="!isInited" element-loading-text="加载中">
    <zj-layout-header>
      <div class="listtitle">事件信息</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="事件名称">
          <el-input v-model="EventName" style="width:50rem"></el-input>
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="EventType" placeholder="请选择" style="width:50rem">
            <el-option>请选择</el-option>
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker placeholder="选择日期" v-model="ReportStartTime" style="width:50rem"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker placeholder="选择日期" v-model="ReportEndTime" style="width:50rem"></el-date-picker>
        </el-form-item>
        <el-form-item class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-header>
    <zj-layout-main>
      <el-table
        v-loading="searching"
        element-loading-text="搜索中"
        :data="tableData"
        height="100%">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="EventName" label="事件名称"></el-table-column>
        <el-table-column prop="EventLocation" label="事发地点"></el-table-column>
        <el-table-column prop="EventLevel" label="事件等级" :formatter="ConvertEventLevel" width="140" align="center"></el-table-column>
        <el-table-column prop="EventType" label="事件类型" :formatter="ConvertEventType" width="140" align="center"></el-table-column>
        <el-table-column prop="EventDate" label="事发时间" :formatter="formatDate" width="140" align="center"></el-table-column>
        <el-table-column prop="ReportTime" label="上报时间" :formatter="formatDate" width="140" align="center"></el-table-column>
        <el-table-column prop="ReporterName" label="上报人" width="140" align="center"></el-table-column>
        <el-table-column prop="ReporterPhone" label="联系方式" width="145" align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.Status==1">
              <el-button  @click="verify(scope.$index,scope.row)" type="text" size="small">核实</el-button>
              <el-button  @click="startUp(scope.row)" type="text" size="small" v-show="false">启动应急</el-button>
            </template>
            <el-button v-else-if="scope.row.Status==2" @click="report(scope.$index,scope.row)" type="text" size="small">确认上报</el-button>
            <el-button v-else-if="scope.row.Status==3" @click="startUp(scope.row)" type="text" size="small">启动应急</el-button>
            <el-button v-else-if="scope.row.Status==8" @click="SeeComfirInfo(scope.$index,scope.row)" type="text" size="small">查看</el-button>
            <template v-else>
              <el-button @click="SeeInfo(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button v-if="scope.row.Status==6" @click="fileInfo(scope.row)" type="text" size="small">归档</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
    <el-dialog v-dialogDrag title="事件归档" :visible.sync="dialogOpts.dialogTableVisible">
      <EventFile :viewData="dialogOpts.rowData" @cancel="dialogCancel" @ok="dialogOk" @search="search"></EventFile>
    </el-dialog>
    <el-dialog v-dialogDrag title="启动应急" :visible.sync="dialogOpts.dialogPlanTableVisible">
      <EventPlan :viewData="dialogOpts.rowData" @cancel="dialogPlanCancel" @ok="dialogPlanOk" @search="search"></EventPlan>
    </el-dialog>
  </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
import EventFile from "./EventFile.vue";
import EventPlan from "./EventPlan.vue";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjEventList",
  controller: "UI",
  action: "EventList",
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object
  }, 
  components: {
    EventFile,EventPlan
  },
  watch: {
    query(newV) {
      // console.log(newV.Status);
      this.Status = parseInt(newV.Status);
      this.clearsearch();
      this.search();
    }
  },
  data() {
    return {
      isInited: false, // 初始化中...
      EventTypeDic: [],
      EventLevelDic: [],
      EventTypeOptions: [],
      EventLevelOptions: [],
      tableData: [],
      EventName: "",
      EventType: null,
      ReportStartTime: null,
      ReportEndTime: null,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      Status: 1,
       dialogOpts: {
        dialogTableVisible: false,
        dialogPlanTableVisible:false,
        rowData: null,
      },
      searching: false // 搜索中...
    };
  },

  created: function() {
    this.init();
    this.search();
  },

  methods: {

    init() {
      this.Status = parseInt(this.query.Status);

      if(this.Status==1){
        this.logInfo.ActionName = "待核实事件查看";
        this.logInfo.LogMessage = "待核实事件查看";
      }else if(this.Status==2){
        this.logInfo.ActionName = "待上报事件查看";
        this.logInfo.LogMessage = "待上报事件查看";
      }else if(this.Status==3){
        this.logInfo.ActionName = "待启动事件查看";
        this.logInfo.LogMessage = "待启动事件查看";
      }else if(this.Status==6){
        this.logInfo.ActionName = "待归档事件查看";
        this.logInfo.LogMessage = "待归档事件查看";
      }else if(this.Status==7){
        this.logInfo.ActionName = "已归档事件查看";
        this.logInfo.LogMessage = "已归档事件查看";
      }else if(this.Status==8){
        this.logInfo.ActionName = "虚报事件查看";
        this.logInfo.LogMessage = "虚报事件查看";
      }
      this.logInfo.ModuleName = "应急系统";
      this.logInfo.PageName = "应急事件信息";
      this.addOperationLog();
      
      utils.waitAll([
        this.config.getUValue("EmergencyService:EmergencyEventLevel", ""),
        this.config.getUValue("EmergencyService:FitEventType", ""),
      ])
      .then(r=>{

        // 事件等级
        const eventlevelconf = r[0];
        this.EventLevelOptions = eventlevelconf.JValue;
        for (let i = 0; i < this.EventLevelOptions.length; i++) {
          let item = this.EventLevelOptions[i];
          this.EventLevelDic[item.ItemKey] = item.Extend1;
        }

        // 事件类型
        const eventtypeconf = r[1];
        this.EventTypeOptions = eventtypeconf.JValue;
        for (let j = 0; j < this.EventTypeOptions.length; j++) {
          let item = this.EventTypeOptions[j];
          this.EventTypeDic[item.ItemKey] = item.Extend1;
        }
        this.isInited = true;
      })
      .catch(e=>{
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });

    },

    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
        EventName: this.EventName,
        EventType: this.EventType,
        ReportStartTime: this.ReportStartTime,
        ReportEndTime: this.ReportEndTime == null
            ? null
            : new Date((this.ReportEndTime / 1000 + 86400) * 1000),
        Status: this.Status
      };
      this.searching = true;
      return new MyApis.EmergencyEventApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.searching = false;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.searching = false;
        });
    },
    clearsearch() {
      this.EventName = "";
      this.EventType = null;
      this.ReportStartTime = null;
      this.ReportEndTime = null;
    },
    // 点击查询按钮
    onSearch() {
       if (new Date(this.ReportEndTime) < new Date(this.ReportStartTime)) {
        this.$message.error("开始日期不能大于结束日期");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //核实
    verify(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ConfirmEvent",
        // name: 'mallList',
        query: { EventId: row.EventId }
      });
    },
    //确认
    report(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ReportEvent",
        // name: 'mallList',
        query: { EventId: row.EventId }
      });
    },
    //启动
    startUp(row) {
       this.dialogOpts.rowData=row;
       this.dialogOpts.dialogPlanTableVisible = true;
    },
    //查看
    SeeInfo(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/SeeEventInfo",
        // name: 'mallList',
        query: { EventId: row.EventId, Status: row.Status }
      });
    },
    SeeComfirInfo(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/SeeEventInfo",
        // name: 'mallList',
        query: { EventId: row.EventId, Status: row.Status ,IsReport:false}
      });
    },
    //归档
    fileInfo(row) {
       this.dialogOpts.rowData=row;
       this.dialogOpts.dialogTableVisible = true;
    },

    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      let dt = new Date(data);
      return dt.format("yyyy-MM-dd hh:mm");
    },
    ConvertEventType(row, column) {
      if(this.Status!=1 && column.property=='EventType'){
        column.property='ConfirmEventType'
      }
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let typestr = this.EventTypeDic[data];
      return typestr;
    },
    ConvertEventLevel(row, column) {
      if(this.Status!=1 && column.property=='EventLevel'){
        column.property='ConfirmEventLevel'
      }
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.EventLevelDic[data];
      return levelstr;
    },
     dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogPlanOk() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    dialogPlanCancel() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
  }
};
</script>